import Icon from '../../components/Icon.vue'

Icon.register({"brands/amilia":{"width":448,"height":512,"paths":[{"d":"M240.1 32C178.2 32 108.6 48.9 55.9 87.4 50.8 90.5 46.8 96.6 48.7 106.8 49.8 111.9 53.8 134.2 58.9 146.4 63 156.6 73.1 156.6 79.2 152.5 111.7 130.2 175.7 104.8 231.5 104.8 289.4 104.8 290.4 133.2 290.4 177.9V216.4C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376S31.5 480 141.2 480C189 480 254.9 459.3 294.5 437.9V463.3C294.5 466.3 296.6 471.5 300.6 472.4 303.7 473.4 351.3 474.4 360.5 474.4S423 474.7 427 473.7C431.1 472.7 432.1 467.6 432.1 464.6V168C432 87.7 374.2 32 240.1 32zM152.2 359.7C152.2 347.5 149.2 317 170.5 306.8 194.8 293.6 245.6 277.4 290.3 273.3V380C268.9 393.2 241.6 404.4 211.2 404.4 158.4 404.4 152.3 370.9 152.2 359.7"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/amilia.js
// module id = VRmL
// module chunks = 0